// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24DZF","left":"styles_left__3Q-Tx"};